import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { yellow } from 'material-ui/colors';

import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles'

import * as stores from './stores'

const theme = createMuiTheme({
    typography: {
        fontFamily: "Kanit-Regular",
    },
    palette: {
        primary: {
            ...yellow,
            contrastDefaultColor: 'light',
        },
        accent: yellow[500],
    },
})

const Root = () => (
    <MuiThemeProvider theme={theme}>
        <App stores={stores} />
    </MuiThemeProvider>
);

ReactDOM.render(
    <Root />,
    document.getElementById('root')
);

registerServiceWorker();

// Webpack Hot Module Replacement API
if (module.hot) {
    module.hot.accept('./App', () => {
        ReactDOM.render(
            <Root />,
            document.getElementById('root')
        );
    })
}


// WEBPACK FOOTER //
// ./src/index.js